// VENDOR PROFILE COMPONENTS DICTIONARY
// https://medium.com/@pratikpatel_60309/dynamic-importing-component-templates-with-vue-js-78d2167db1e7
export const vendorProfileComponents = [
    {
        text: "Shipments",
        icon: "local_shipping",
        name: "shipments",
        import: () => import("Modules/companies/vendors/components/Shipments.vue"),
        permission: "",
    },
];
